export default "__VITE_ASSET__Dv9ZI1dl__"